import React, { useState, useEffect } from "react";
import "./AddUserForm.css"; // Ensure proper styling

const AddUserForm = ({ onClose, onUserAdded }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    role_id: "",
  });

  const [roleOptions, setRoleOptions] = useState([]);  
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("/api/roles")
      .then((response) => response.json())
      .then((data) => setRoleOptions(data))
      .catch((error) => console.error("Error fetching roles options:", error));
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name || !formData.last_name || !formData.email || !formData.phone || !formData.role_id) {
      setError("All fields are required.");
      return;
    }

    try {
      const response = await fetch("/api/admin/add-user", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to add user.");
      }

      alert("✅ User added successfully!");
      setTimeout(() => {
        onUserAdded(); // Refresh user list
        onClose(); // Close modal
      }, 300);
    } catch (error) {
      console.error("❌ Error adding user:", error.message);
      setError(error.message || "An error occurred.");
    }
  };

  return (
    /** ✅ Wrap everything in a <div> to avoid ESLint error */
    <div className="modal-overlay">
      <div className="modal-content">
        {/* Close Button */}
        <button className="close-button" onClick={onClose}>✖</button>

        <h3>Add User</h3>

        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label id="add-user-label">First Name:</label>
            <input id="add-user-input" type="text" name="first_name" value={formData.first_name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label id="add-user-label">Last Name:</label>
            <input id="add-user-input" type="text" name="last_name" value={formData.last_name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label id="add-user-label">Email:</label>
            <input id="add-user-input" type="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label id="add-user-label">Mobile:</label>
            <input id="add-user-input" type="text" name="phone" value={formData.phone} onChange={handleChange} required />
          </div>
          <div className="form-group">
          <label id="add-user-label">Access Level:</label>
          <select id="add-user-input" name="role_id" value={formData.role_id} onChange={handleChange} required>
            {roleOptions.map((role) => (
              <option key={role.role_id} value={role.role_id}>
                {role.role_name}
              </option>
            ))}
          </select>
          </div>
            {/* Display error message */}
          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="submit-btn">Add User</button>
        </form>
      </div>
    </div>
  );
};

export default AddUserForm;
